
export const ALREADY_IN_PRELAB = 'already received in Prelab';
export const ALREADY_IN_AID = 'already received in AID';
export const NO_LAB_DELIVERY = 'Lab delivery is pending'
export const EVENT_NOT_EXISTS = 'No APO details found for the given APO';
export const CAN_NOT_UPLOAD = 'Images cannot be uploaded';
export const CAN_NOT_UPLOAD_MSG = 'The event selected does not have a PIB completed so images cannot be uploaded. Lab delivery will need to be done in order to upload images';
export const CHECK_FAILED = 'Quarantine validation FAILED';
export const CONFIRM_TITLE = 'Change and Upload Confirmation';
export const MARK_RESOLVE_TITLE = 'Mark as Resolved Confirmation';
export const INACTIVE_EVENT = 'is not active';

export interface QuarantineErrorMessage {
  error: string;
  detailReason: string;
  heading: string;
}

export const quarantineErrorMessages: QuarantineErrorMessage[] = [
  {
    error: ALREADY_IN_PRELAB,
    heading: 'Event is already in Prelab',
    detailReason: 'The event you are trying upload the images to is already in Prelab and images cannot be uploaded to that event',
  },
  {
    error: ALREADY_IN_AID,
    heading: 'Event is already in AID',
    detailReason: 'The event you are trying upload the images to is already in AID and images cannot be uploaded to that event',
  },
  {
    error: NO_LAB_DELIVERY,
    heading: CAN_NOT_UPLOAD,
    detailReason: CAN_NOT_UPLOAD_MSG,
  },
  {
    error: EVENT_NOT_EXISTS,
    heading: 'Event does not exists',
    detailReason: 'The event you are trying to upload the images to does not exists',
  },
  {
    error: INACTIVE_EVENT,
    heading: 'Event is not active',
    detailReason: 'The event to which you are trying to upload the images is inactive',
  }
]